import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const Orders = ({match}) => (
  <div className="app-wrapper">
    <Switch>
        <Route path={`${match.url}/smspurchaselog`} component={asyncComponent(() => import('./routes/smspurchaselog'))}/>
     
    
    
    
        <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>

    </Switch>
  </div>
);

export default Orders;